import { render, staticRenderFns } from "./people-counter.vue?vue&type=template&id=30f03bca&scoped=true"
import script from "./people-counter.vue?vue&type=script&lang=js"
export * from "./people-counter.vue?vue&type=script&lang=js"
import style0 from "./people-counter.vue?vue&type=style&index=0&id=30f03bca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f03bca",
  null
  
)

export default component.exports